import React, { useRef } from 'react'
import { motion, useScroll } from 'framer-motion'
import HeroSection from '../components/HeroSection'
import ValueProps from '../components/ValueProps'
import HowItWorks from '../components/HowItWorks'
import Testimonials from '../components/Testimonials'
import CallToAction from '../components/CallToAction'
import Footer from '../components/Footer'

const Home = () => {
  const containerRef = useRef(null)
  const { scrollYProgress } = useScroll()

  return (
    <div className="min-h-screen" ref={containerRef}>
      <HeroSection />
      <ValueProps />
      <HowItWorks />
      <Testimonials />
      <CallToAction />
      <Footer />
    </div>
  )
}

export default Home